import request from '@/untils/request'
export default {
  // 验证码
  codess(data){
    return request({
        url: "/ticketAppUser/getSMSByPhone",
        methods: "post",
        params: {
          "phone": data.username,
          "verifycode": data.verifycode
        }
    })
  },

  // 注册
  registered(data) {
    return request({
      url: "/ticketAppUser/registered",
      methods: "post",
      params: {       
        // "phone": Base64.encode(data.username),
        "phone": data.username,
        "vcode": data.code,
        // "password": Base64.encode(data.password)
        "password": data.password
      }
    })
  },

  
  // 获取验证码
  getVerifyCode(params) {
    return request({
      url: "/ticketAppUser/getVerifyCode"+Math.random(),
      methods: "post",
      params
    })
  },


};



// WEBPACK FOOTER //
// ./src/api/registered.js